import { useTranslation } from "react-i18next";

import { useMediaQuery } from "@mui/material";
import i18n from "i18next";

import { types } from "../../../../../utils/constants";

import { useActions } from "../../../../../hooks/use-actions";

import { MenuIcon } from "../../../../../assets/img/svg/MenuIcon";
import { CustomLink } from "../../../../custom-link/custom-link";
import { SvgComponent } from "../../../SvgComponent";
import { addStyles } from "./addStyles";

import { IconBox } from "../../../../icon-box/IconBox.styled";
import { TitleH4 } from "../../../../ui/TitleH4/TitleH4.styled";
import {
  Dollar,
  Item,
  Month,
  Price,
  StyledImg,
  TextOne,
  TextTwo,
  WrapperOne,
  WrapperPrice,
  WrapperRoot,
  WrapperTwo,
} from "./DropDownItem.styled";

export const DropDownItem = ({
  icon,
  iconSvg = "",
  iconUrl = "",
  title,
  description,
  price = null,
  link = "/",
  providerUrl = "",
  type = "",
  currencyIsoCode = "",
  pricePeriod = "",
  isTools,
  closeMenu,
  onClick,
  isActive,
}) => {
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up("md"));
  const { setMenu } = useActions();

  const { t } = useTranslation();

  const currentLanguage = i18n.language;
  const newLang = currentLanguage === "en" ? "" : `/${currentLanguage}`;

  const gridSize = !isTools ? 12 : 6;

  const onCloseClick = () => {
    isLargeScreen ? closeMenu() : setMenu(false);
  };

  const newLink = providerUrl ? providerUrl : `${newLang}${link}`;

  return (
    <Item
      component="li"
      size={{ xs: 12, md: gridSize }}
      onClick={onClick}
      isactive={isActive ? "true" : undefined}
    >
      <CustomLink
        target={providerUrl ? "_blank" : "_self"}
        to={newLink}
        onClick={onCloseClick}
      >
        <WrapperRoot>
          <WrapperOne>
            {(icon || providerUrl) && (
              <IconBox addStyles={addStyles} data-ip="icons">
                {icon && <MenuIcon tag={icon} />}

                {iconSvg && <SvgComponent svgString={iconSvg} />}

                {iconUrl && !iconSvg && (
                  <StyledImg src={iconUrl} alt="icon" width="24" height="24" />
                )}

                {!icon && !iconSvg && !iconUrl && (
                  <MenuIcon tag={types.includes(type) ? type : "IPv4"} />
                )}
              </IconBox>
            )}

            <div>
              <TitleH4>{title}</TitleH4>
              <TextOne isTools={isTools}>{description}</TextOne>
            </div>
          </WrapperOne>

          {price && (
            <WrapperTwo>
              <TextTwo price={price}>{t("header.proxies.startsFrom")}</TextTwo>

              {price !== "0" ? (
                <WrapperPrice>
                  <Dollar>{currencyIsoCode}</Dollar>
                  <Price>{price}</Price>
                  <Month variant="light14">/{pricePeriod}</Month>
                </WrapperPrice>
              ) : (
                <span>{t("header.proxies.freePrice")}</span>
              )}
            </WrapperTwo>
          )}
        </WrapperRoot>
      </CustomLink>
    </Item>
  );
};
